import { Stack } from '@mantine/core';
import { AgentSession } from '../../../api/events-client/events-client.type';
import { ContentPlaceholder } from '../../../components/content-placeholder/content-placeholder';
import { Table, TableColumn } from '../../../components/table/table';
import { Text } from '../../../ui-library/typography/typography';

interface AgenticProcessSessionsTableProps {
  sessions: AgentSession[];
  columns: TableColumn<AgentSession>[];
  navigateToSessionMap: (sessionId: string) => void;
}

export const AgenticProcessSessionsTable = ({
  sessions,
  columns,
  navigateToSessionMap,
}: AgenticProcessSessionsTableProps) => {
  if (sessions.length === 0) {
    return <ContentPlaceholder icon="group_work" text="No agent sessions found for the selected time period." />;
  }

  return (
    <Stack gap="md">
      <Text weight="bold" size="large">
        Agent Sessions
      </Text>

      <Table
        data={sessions}
        columns={columns}
        getRowId={(row) => row.session_id}
        stickyHeader={true}
        totalItems={sessions.length}
        onRowClick={(row) => navigateToSessionMap(row.session_id)}
      />
    </Stack>
  );
};
